// 通用的一些名词
export default {
    'common.language.change':'изменить язык',
    'common.company.name':'Международная логистическая компания « дацян» (Шэньчжэнь)',
    'common.company.copyright':'Авторское право © 2022 Международная логистическая компания « дацян» (Шэньчжэнь)',
    'common.company.beian.icp':'Су ICP підготовлено',
    'common.company.beian.gwa':'Су Безпека загальнодоступної мережі №',
    'common.company.address-title':'Адрес:',
    'common.company.address-info':'промышленный парк Даланг, район Лунхуа, город Шэньчжэнь, провинция Гуандун.',
    'common.navigation.title.home':'Главная',
    'common.navigation.title.about':'Про нас',
    'common.navigation.title.query':'Заявка на перевозку',
    'common.navigation.title.track':'Маршрут доставки',
    'common.navigation.title.contact':'Связаться с нами (контакты)',
    'common.footer.slogan':'Компания DawnTron с момента основания постоянно стремится улучшать свои показатели качества оказания услуг и постоянно совершает прорыв на рынке логистики. Благодаря многолетнему опыту компания сформировала уникальную систему логистических услуг и гарантированно предоставляет своим клиентам профессиональные и эффективные логистические решения по всему миру!',
    'common.footer.map.website-map':'КАРТА САЙТА',
    'common.footer.map.help-center':'ТЕХ ПОДДЕРЖКА',
    'common.footer.map.help-center.question':'Часто задаваемые вопросы',
    'common.footer.map.help-center.service':'Обслуживание клиентов',
    'common.footer.map.help-center.message':'Оставить заявку',
    'common.footer.map.help-center.price':'Запрос цены ',
    'common.footer.map.contact-us':'СВЯЖИТЕСЬ С НАМИ',
    'common.footer.map.contact-us.whatsApps':'WhatsApp: +86 18576744474',
    'common.footer.map.contact-us.skype':'skype: +86 18576744474',
    'common.footer.dialog.title':'Tips',
    'common.footer.dialog.content':'For any question please contact : телефон: +86 18688782252, whatsApp,skype +86 18576744474'
}